/**
 * Teste QA com versões por GERÊNCIA (Matheus, 05/10/2026; conteúdo no anexo `teste-qa-versoes-gerencia.json`).
 *
 * UM lugar para a correspondência entre a gerência do organograma (`rh_areas.gerencia`, Parte B) e a chave do anexo —
 * decisão do Matheus de 05/10: *"vale o nome do organograma. No anexo do QA, a chave operacional corresponde à gerência
 * Operacional, a chave comercial à Comercial e a chave administrativo à Administrativa"*. O servidor importa daqui
 * (direção da casa: servidor → tipos do front). Um teste reprova se uma gerência do organograma ou uma chave do anexo
 * ficar sem par.
 */

export type GerenciaQa = 'operacional' | 'comercial' | 'administrativo';

/** As opções do campo "Versão do teste", na ordem do organograma; o rótulo é o nome da gerência na ficha. */
export const VERSOES_DO_QA: ReadonlyArray<{ valor: GerenciaQa; rotulo: string }> = [
  { valor: 'operacional', rotulo: 'Operacional' },
  { valor: 'comercial', rotulo: 'Comercial' },
  { valor: 'administrativo', rotulo: 'Administrativa' },
];

/** Literal do pedido de 05/10. */
export const CAMPO_VERSAO_DO_TESTE = 'Versão do teste';

/** A gerência da ficha (o NOME do organograma) → a versão do QA. `null` = sem versão automática (sem área, ou a Diretoria). */
export function gerenciaQaDaGerencia(gerencia: string | null | undefined): GerenciaQa | null {
  return VERSOES_DO_QA.find((v) => v.rotulo === gerencia)?.valor ?? null;
}
